module.exports = __webpack_public_path__ + "static/media/tick.0ee05079.png";